jQuery(document).ready(function ($) {
    $('#delete_user_button').on('click', function(e){
        e.preventDefault();
        $('.popup[form=#form_delete_user]').fadeIn();
    });

});